var $ = require('jquery'),
  ko = require('knockout');
require('knockout-postbox');

var hashHelper = function(filterTopic) {
  var self = this;

  self.validHashes = {
    fromDate: 'fra',
    toDate: 'til',
    searchTerm: 'q',
    place: 'sted',
    update: 'oppdatering',
    sort: 'sortering',
    type: 'type',
    role: 'rolle',
    year: 'aar',
    category: 'kategori',
    page: 'side'
  };

  var decodeHash = function(hash) {
    hash = hash.replace('#', '');
    var elements = hash.split('&');
    var dictionary = {};
    for (var x = 0; x < elements.length; x++) {
      var pair = elements[x].split('=');
      if (pair.length == 2) {
        dictionary[pair[0]] = window.decodeURIComponent(pair[1]);
      }
    }
    return dictionary;
  };

  var encodeHash = function(hash) {
    if ($.isEmptyObject(hash)) return '_';

    var separator = '';
    var hashString = '';
    for (var el in hash) {
      if (hash.hasOwnProperty(el)) {
        hashString += separator + el + '=' + hash[el];
        separator = '&';
      }
    }
    return '#' + hashString;
  };

  self.getHashValue = function(key) {
    var currentHash = decodeHash(location.hash);
    return currentHash[key];
  };

  self.setHashValue = function(key, value) {
    var currentHash = decodeHash(location.hash);

    if (value === undefined || value === '') {
      delete currentHash[key];
    } else {
      currentHash[key] = value;
    }
    location.hash = encodeHash(currentHash);
  };

  self.getListener = function(key, defaultValue, ignoreInitialValue) {
    var obs = ignoreInitialValue
      ? ko.observable()
      : ko.observable(self.getHashValue(key) || defaultValue);
    obs.subscribe(function(newValue) {
      if (parseInt(newValue, 10) === -1) {
        self.setHashValue(key, undefined);
      } else {
        if (newValue !== self.getHashValue(key)) {
          self.setHashValue(key, newValue);
        }
      }
    });
    return obs;
  };

  self.getDateListener = function(key) {
    var obs = ko.observable(new Date(parseInt(self.getHashValue(key))));
    obs.subscribe(function(val) {
      if (val === undefined) {
        self.setHashValue(key, val);
        return;
      }
      var time = val.getTime();
      if (isNaN(time)) return;
      self.setHashValue(key, time);
    });
    return obs;
  };

  var updateFilters = function() {
    var hash = decodeHash(location.hash);

    var fromDate = parseInt(hash[self.validHashes.fromDate]);
    var toDate = parseInt(hash[self.validHashes.toDate]);
    var correctedFromDate = isNaN(fromDate) ? '' : new Date(fromDate).toJSON();
    var correctedToDate = isNaN(toDate) ? '' : new Date(toDate).toJSON();
    ko.postbox.publish(filterTopic, {
      name: hash[self.validHashes.searchTerm],
      city: hash[self.validHashes.place],
      authorizationCreditPk: hash[self.validHashes.update],
      order: hash[self.validHashes.sort],
      eventType: hash[self.validHashes.type],
      role: hash[self.validHashes.role],
      fromDate: correctedFromDate,
      toDate: correctedToDate,
      year: hash[self.validHashes.year],
      category: hash[self.validHashes.category],
      page: hash[self.validHashes.page]
    });
  };
  updateFilters();
  window.onhashchange = updateFilters;
};

module.exports = hashHelper;
